export default __webpack_public_path__ + "static/media/cyclist.558398a4.jpg";